import { clearWcpClientAuthState } from './session';

const GUEST_EXPLORE_SESSION_KEY = 'guestExploreIntent';

export function isGuestExplorePending(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        return sessionStorage.getItem(GUEST_EXPLORE_SESSION_KEY) === '1';
    } catch {
        return false;
    }
}

export function hasGuestExploreIntent(): boolean {
    return isGuestExplorePending();
}

/** Wipe prior WCP session when guest explore intent is active in sessionStorage. */
export function consumeGuestExploreIntent(): boolean {
    if (!isGuestExplorePending()) {
        return false;
    }

    clearWcpClientAuthState();
    return true;
}

export function completeGuestExploreIntent(): void {
    try {
        sessionStorage.removeItem(GUEST_EXPLORE_SESSION_KEY);
    } catch {
        // ignore
    }
}
